import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";

export class TreatingPhysicianFirstNameFieldController extends GeneralTreatingPhysicianFieldController {}
